import {
  Button,
  Heading,
  Text,
  Alert,
  AlertIcon,
  Input,
} from '@chakra-ui/react';
import { useContext, useState, useEffect } from 'react';
import UserContext from '../../context/userContext';
import { liberarFechas } from '../../services/liberarFechas';
import { obtenerNoches } from '../../services/obtenerNoches';
import { ModalLiberarNoches } from './ModalLiberarNoches';
import { useDisclosure } from '@chakra-ui/react';
import { verifyAuth } from '../../helpers/verifyAuth';
import { useNavigate } from 'react-router';
import { Loading } from '../Common/Loading';
import CustomInputSelect from '../Common/InputSelect';
import { useTranslation } from 'react-i18next';

export const LiberarNoches = () => {

  const { t } = useTranslation();

  const { user, setUser } = useContext(UserContext);
  const [nochesA, setNochesA] = useState([
    { value: '', text: t('SELECT_NUMBER_NIGHTS') },
  ]);
  const [nochesB, setNochesB] = useState([
    { value: '', text: t('SELECT_NUMBER_NIGHTS') },
  ]);
  const [selectedNochesA, setSelectedNochesA] = useState(0);
  const [selectedNochesB, setSelectedNochesB] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState({ error: false, msg: '' });
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();

  const disabled = isLoading || !user?.numeroNoches;

  const [modalOpen, setModalOpen] = useState(false);
  const [inputErrors, setInputErrors] = useState({
    nochesLiberadas: '',
  });

  const validateNumberNoches = (numeroNoches, numeroMaximoNoches) => {
    if (numeroNoches.trim() === '') {
      return { error: true, msg: t('FIELD_REQUIRED') };
    }
    const containsOnlyDigits = /^\d+$/.test(numeroNoches);
    if (!containsOnlyDigits) {
      return { error: true, msg: t('NO_SPECIAL_CHARACTERS') };
    }
    if (parseInt(numeroNoches, 10) < 1) {
      return { error: true, msg: t('FIELD_REQUIRED') };
    }
    if (parseInt(numeroNoches, 10) > parseInt(numeroMaximoNoches, 10)) {
      return {
        error: true,
        msg: t('NIGHTS_EXCEED_LIMIT', { nights: numeroMaximoNoches }),
      };
    }
    return { error: false, msg: '' };
  };

  const populateSelects = () => {
    const auxA = [];
    const auxB = [];
    for (let i = 1; i <= user?.numeroNoches % 7; i++) {
      auxA.push({ text: String(i), value: i });
    }
    for (let i = 1; i <= Math.trunc(user?.numeroNoches / 7); i++) {
      auxB.push({ text: String(i * 7), value: i * 7 });
    }
    setNochesA([{ value: 0, text: t('SELECT_A_DATE') }, ...auxA]);
    setNochesB([{ value: 0, text: t('SELECT_A_DATE') }, ...auxB]);
  };

  const validateForm = () => {
    if (selectedNochesA !== 0 || selectedNochesB != 0) {
      return true;
    } else {
      return false;
    }
    /*const numeroNochesvalidation = validateNumberNoches(fechas, user?.numeroNoches);
    const errors = {
      nochesLiberadas: numeroNochesvalidation.error ? numeroNochesvalidation.msg : ''
    }
    setInputErrors(errors);
    return Object.values(errors).every((error) => error === '');*/
  };

  const handleLiberarFecha = () => {
    setIsLoading(true);

    //const parsedFechas = parseInt(fechas, 10);
    liberarFechas(user.id, parseInt(selectedNochesA), parseInt(selectedNochesB))
      .then((res) => {
        if (res.status === 200) {
          onOpen();
          const foto = user.foto;
          setUser({ ...res.data.titularActualizado, foto });
        }
      })
      .catch((err) => {
        setError({
          error: true,
          msg: `${err.response.data.error}`,
        });
        //window.location.reload(true);
      })
      .finally(() => setIsLoading(false));
  };

  const handleChange = (e) => {
    if (e.target.name === 'nochesA') {
      setSelectedNochesA(e.target.value);
    } else {
      setSelectedNochesB(e.target.value);
    }
  };

  const handleOpenModal = () => {
    if (validateForm()) {
      setModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    populateSelects();
  };

  const handleConfirmarLiberacion = () => {
    handleLiberarFecha();
    handleCloseModal();
  };

  useEffect(() => {
    const controller = new AbortController();
    setIsLoading(true);
    (async () => {
      try {
        const {
          data: { titular },
        } = await obtenerNoches(user.id, controller.signal);
        if (titular) {
          setUser({ ...user, numeroNoches: titular.numeroNoches });
          setError({ error: false, msg: '' });
        }
        setIsLoading(false);
      } catch (err) {
        await verifyAuth(err?.response?.status, setUser, navigate);
      }
    })();

    return () => {
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error.error]);

  useEffect(() => {
    populateSelects();
  }, [nochesA, nochesB]);

  if (user.rol !== 'TITULAR') {
    return null;
  }
  if (user.moroso) return null;

  if (isLoading) return <Loading />;

  return (
    <div className="mx-5 my-3">
      <ModalLiberarNoches
        isOpen={modalOpen}
        onClose={handleCloseModal}
        nochesLiberadas={parseInt(selectedNochesA) + parseInt(selectedNochesB)}
        onConfirm={handleConfirmarLiberacion}
      />
      <Heading
        mb="3"
        size="lg"
      >
        {t('SELECT_NIGHTS_TO_RELEASE')}
      </Heading>
      {error.error && <Text className="text-danger">{error.msg}</Text>}
      <section className="w-25 pb-2">
        <p className="py-1">{t('AVAILABLE_NIGHTS', { nights: user?.numeroNoches })}</p>
        <br></br>

        <CustomInputSelect
          label={t('LOW_SEASON_NIGHTS_TO_RELEASE')}
          name="nochesB"
          value={selectedNochesB}
          options={nochesB}
          onChange={handleChange}
        />

        <CustomInputSelect
          label={t('HIGH_SEASON_NIGHTS_TO_RELEASE')}
          name="nochesA"
          value={selectedNochesA}
          options={nochesA}
          onChange={handleChange}
        />

        {inputErrors.nochesLiberadas !== '' ? (
          <Alert
            status="error"
            my={2}
            width={380}
          >
            <AlertIcon />
            {inputErrors.nochesLiberadas}
          </Alert>
        ) : null}
      </section>
      <Button
        colorScheme="blue"
        onClick={handleOpenModal}
        isDisabled={disabled}
        style={{
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      >
        {t('RELEASE_NIGHTS')}
      </Button>
    </div>
  );
};
